module.exports = __webpack_public_path__ + "media/bootstrap-icons/receipt-cutoff-26b1371b.svg";